module.exports = __webpack_public_path__ + "img/circle-red.0dc78056.svg";